import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "@environments/environment";

import { TranslateService } from '@ngx-translate/core';
declare var $: any; // TODO hide modal in othe way

// Services
import {
  UserService,
  AuthService,
  ResourceService
} from "@services/index.service";
import { PortalConfigurationService } from '@services/portal-configuration/portal-configuration.service';

// Constants
import { AppConstants } from '@app/appConstants';

//Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

/** Barra de navegación. Muestra todas las pestañas de la aplicación basandose en la lógica de si el usuario está logueado o no
 * y en los valores del entorno lo que nos permite adaptarla a los diferentes clientes
 */
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnInit {

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    this._userService.lastActivityTime = +new Date();
  }

  login: any = {
    username: null,
    password: null,
  };
  /** Valor para un segundo logo especial por si incluye texto traducido en la imagen */
  environment = environment;
  environmentName = environment.envName;
  NAVBARMAINCOLOR = environment.NAVBARMAINCOLOR;
  LOGO = environment.LOGO;
  alert: string;
  /** String traducible para mostrar mientras se produce el logueo */
  loging: string = 'LOGIN';
  /**Valores extraidos del environment para saber las propiedades del sitio a construir */
  hasMydepents = environment.HASMYDEPENTS
  hasMyDocuments = environment.HASMYDOCUMENTS
  hasSecondOpinion = environment.SECONDOPINION.HAS
  hideLanguageSelector = environment.HIDELANGUAGESELECTOR;
  adminNavBar = environment.ADMINNAVBAR;
  resourcesOnDatabase = environment.RESOURCES_ON_DATABASE;

  constructor(public router: Router,
    public _portalConfigurationService: PortalConfigurationService,
    public _userService: UserService,
    public _authService: AuthService,
    public _resourceService: ResourceService,
    public translate: TranslateService) {
    this.translate.use(environment.DEFAULTLANGUAGE);
  }

  getBrowserInfo() {
    var ua = navigator.userAgent, tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  };

  /** Elimina todas las posibles alertas */
  clearAlerts() {
    delete this._userService.danger;
    delete this._userService.warning;
    delete this._userService.success;
    delete this._resourceService.alert;
    delete this._authService.alert;
  }


  /** Eliminamos las alegras y pasamos la información al  AuthService*/
  doLogin() {
    this.clearAlerts();
    this._authService.loginUser(this.login.username, this.login.password);
    // delete this.login.username;
    delete this.login.password;
  }

  /** Simplemente llamamos al AuthService */
  logout() {
    this._authService.logout();
    delete this.login.username;
    delete this.login.password;
  }

  /** Cogemos el nuevo mail y lo enviamos al _userService si la respuesta es ok avisamos de que se le ha enviado la 
   * nueva pass, si no le mostramos el mensaje de error. También mostramos el modal de login y ocultamos el de resseta pass
   */
  resetPassword() {
    let data = {
      email: this.login.username
    }
    this._userService.setUserData('resetpass', data).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this._userService.success = 'SEND_EMAIL_WITH_NEW_PASWORD';
      } else {
        this._userService.warning = response.METADATA.ERROR_MESSAGE
      }
      this._userService.loading = false;
      $('#LoginModal').modal('show');
      $('#ResetPasswordModal').modal('hide');
      window.scrollTo(0, 0);
    });
  }

  resendActivationMail() {
    this._authService.loading = true;
    this._userService.resendActivationMail(this.login.username).subscribe(data => {
      let response = data as unknown as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this._authService.alert = 'PLEASE_CONFIRM_YOUR_MAIL';
      } else {
        this._userService.warning = response.METADATA.ERROR_MESSAGE
      }
      this._authService.loading = false;
    });
  }

  ngOnInit() {
    this.clearAlerts();
    /*  // Esto lo usamos si queresmos detectar un navegador concreto y lanzar un aviso.   
        if (this.getBrowserInfo() == 'IE 11') {
          $('#OldBrowserDetected').modal('show');
        } */
  }

}
